import { computed, makeObservable } from 'mobx'

import { Collection } from 'modules/core/lib/mobx-rest'

import LeaveType from 'modules/timeoff/store/models/LeaveType'

export class LeaveTypes extends Collection<LeaveType> {
  constructor(data: any = []) {
    super(data)
    makeObservable(this, {
      active: computed,
    })
  }

  get cacheKey(): string {
    return 'leaveTypes'
  }

  model() {
    return LeaveType
  }

  get active(): LeaveType[] {
    return this.models.filter((leaveType) => leaveType.attributes.active)
  }

  get archived(): LeaveType[] {
    return this.models.filter((leaveType) => !leaveType.attributes.active)
  }

  isMedicalLeave(id: number): boolean {
    const type = this.find({
      id,
    })

    if (!type) {
      throw Error(`Error finding leaveTypes with id = ${id}`)
    }

    return type.isMedicalLeave
  }
}

const singleton: LeaveTypes = new LeaveTypes()

export default singleton
